import { DestinationKind, DestinationList } from 'types/stream';

type GetDestinationsByKindProps = {
  list: DestinationList;
  kind: DestinationKind;
  selectedIds: string[];
};

const getFacebookDestinationsByKind = ({ list, kind, selectedIds }: GetDestinationsByKindProps) => {
  const destinationsList = list.filter(d => d.kind === kind && d.network === 'FACEBOOK');

  const mappedList = destinationsList.map(d => ({ ...d, isChecked: selectedIds.includes(d.id) }));

  return mappedList;
};

const getFacebookDestinations = (list: DestinationList, selectedIds: string[]) => {
  const pages = getFacebookDestinationsByKind({ list, selectedIds, kind: 'page' });
  const groups = getFacebookDestinationsByKind({ list, selectedIds, kind: 'group' });
  const profiles = getFacebookDestinationsByKind({ list, selectedIds, kind: 'profile' });

  return [pages, groups, profiles] as const;
};

export default getFacebookDestinations;
